import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5b476c31&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=5b476c31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b476c31",
  null
  
)

export default component.exports